export const version = "09.10.1"

export const BACKEND_URL_PREFIX = process.env.REACT_APP_BACKEND_URL
export const BACKEND_DOMAIN = process.env.REACT_APP_BACKEND_DOMAIN
export const LIVEKIT_URL = process.env.REACT_APP_LIVEKIT_URL


export const SHARE_SCREEN_NAME = "_screen-share_";


export const MONTHS = [
  "",
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];
